module.exports = __webpack_public_path__ + "img/3.7994e90.png";